import { isDefined } from "@clipboard-health/util-ts";
import { BookabilityUnmetCriteria } from "@src/appV2/OpenShifts/ShiftAction/types";

const shiftErrorPrefix = "Shift cannot be booked because";

export const bookShiftErrors: Record<BookabilityUnmetCriteria, string> = {
  [BookabilityUnmetCriteria.FACILITY_CHARGE_RATE_MISSING]: `${shiftErrorPrefix} facility charge rate is missing.`,
  [BookabilityUnmetCriteria.FACILITY_PENDING]: `${shiftErrorPrefix} facility is in pending state.`,
  [BookabilityUnmetCriteria.FACILITY_SUSPENDED]: `${shiftErrorPrefix} facility is suspended.`,
  [BookabilityUnmetCriteria.SHIFT_ALREADY_GRABBED]: `${shiftErrorPrefix} is it not available.`,
  [BookabilityUnmetCriteria.SHIFT_DELETED]: `${shiftErrorPrefix} it is not available.`,
  [BookabilityUnmetCriteria.SHIFT_IN_PAST]: `${shiftErrorPrefix} it is in the past and cannot be booked.`,
  [BookabilityUnmetCriteria.SHIFT_INSTANT_BOOK_DISABLED]: `${shiftErrorPrefix} it is not available for instant book.`,
  [BookabilityUnmetCriteria.SHIFT_INSTANT_BOOK_LEAD_TIME_NOT_SET]: `${shiftErrorPrefix} it is not available for instant book.`,
  [BookabilityUnmetCriteria.SHIFT_INVALID]: `${shiftErrorPrefix} it is invalid.`,
  [BookabilityUnmetCriteria.SHIFT_OVERLAPPING]: `${shiftErrorPrefix} it is overlapping with another shift/shift-block.`,
  [BookabilityUnmetCriteria.SHIFT_OVERWORKING]: `${shiftErrorPrefix} of overworking shifts.`,
  [BookabilityUnmetCriteria.WORKER_ACCOUNT_IN_REVIEW]: `${shiftErrorPrefix} your account is in review.`,
  [BookabilityUnmetCriteria.WORKER_CANT_CLAIM_SHIFT]: `${shiftErrorPrefix} you cannot claim this shift.`,
  [BookabilityUnmetCriteria.WORKER_DEACTIVATED]: `${shiftErrorPrefix} your account is deactivated.`,
  [BookabilityUnmetCriteria.WORKER_DISABLED_TEST_ACCOUNT]: `${shiftErrorPrefix} your account is a test account.`,
  [BookabilityUnmetCriteria.WORKER_MISSING_LICENSE]: `${shiftErrorPrefix} you are missing a required license.`,
  [BookabilityUnmetCriteria.WORKER_MISSING_REQUIREMENTS]: `${shiftErrorPrefix} you are missing requirements.`,
  [BookabilityUnmetCriteria.WORKER_PAYMENTS_DISABLED]: `${shiftErrorPrefix} you are not enrolled on stripe.`,
  [BookabilityUnmetCriteria.WORKER_PENDING_DOCUMENTS]: `${shiftErrorPrefix} you have a pending required document.`,
  [BookabilityUnmetCriteria.WORKER_RESTRICTED]: `${shiftErrorPrefix} your account is restricted.`,
  [BookabilityUnmetCriteria.WORKER_UNSIGNED_AGREEMENT]: `${shiftErrorPrefix} you have not signed the latest contractor agreement.`,
  [BookabilityUnmetCriteria.WORKER_HAS_INCOMPLETE_CHARTING]: `${shiftErrorPrefix} you have incomplete charting.`,
  [BookabilityUnmetCriteria.WORKER_HAS_NOT_PASSED_QUIZ_FOR_WORKPLACE_RULES]: `${shiftErrorPrefix} you have not passed the quiz for workplace rules.`,
  [BookabilityUnmetCriteria.WORKER_HAS_NOT_PASSED_ASSESSMENTS]: `${shiftErrorPrefix} you have not passed the assessment.`,
  [BookabilityUnmetCriteria.WORKER_HAS_REACHED_DNR_LIMIT]: `${shiftErrorPrefix} you have reached the maximum DNR limit.`,
  [BookabilityUnmetCriteria.WORKER_HAS_REACHED_MAX_HOURS_PER_WEEK]: `${shiftErrorPrefix} you have reached the maximum number of worked hours per week.`,
  [BookabilityUnmetCriteria.WORKER_HAS_REACHED_MAX_CONSECUTIVE_HOURS]: `${shiftErrorPrefix} you have reached the maximum number of consecutive hours worked`,
  [BookabilityUnmetCriteria.WORKER_MULTI_FACILITY_WEEKLY_HOUR_MAXIMUM]: `${shiftErrorPrefix} you have reached the maximum number of worked hours per week across multiple facilities.`,
};

const isValidBookabilityUnmetCriteria = (
  bookabilityUnmetCriteria: string | undefined
): bookabilityUnmetCriteria is BookabilityUnmetCriteria => {
  return isDefined(bookabilityUnmetCriteria) && bookabilityUnmetCriteria in bookShiftErrors;
};

export function getBookabilityUnmetCriteriaMessage(
  bookabilityUnmetCriteria: string | undefined
): string | undefined {
  if (!isValidBookabilityUnmetCriteria(bookabilityUnmetCriteria)) {
    return undefined;
  }

  return bookShiftErrors[bookabilityUnmetCriteria];
}
